import { useSetRecoilState } from "recoil";
import { parentCompaniesAtom } from "../miscellaneous/parentCompaniesAtom";

export const useSetParentCompaniesState = () => {
  return useSetRecoilState(parentCompaniesAtom);
};
